import { useEffect } from 'react';
import { useSocket } from 'sonata-platform-components';

import type { BuyerInsightsData } from '@/types/footfall';

type BuyerInsightsReadyPayload = {
  entityId: string;
  geoDataId: number;
  outputData: BuyerInsightsData;
  week: string;
};

type Options = {
  activePoiId: string;
  entityId: string;
  onReady: (data: BuyerInsightsData) => void;
  week: string | null;
};

export function useBuyerInsightsSocket({ entityId, activePoiId, week, onReady }: Readonly<Options>) {
  const { offEvent, onEvent } = useSocket();

  useEffect(() => {
    if (!week) {
      return;
    }

    const socketKey = `buyerInsights:${entityId}:${activePoiId}:${week}`;

    onEvent(socketKey, 'footfallBuyerInsightsReady', (payload: BuyerInsightsReadyPayload) => {
      if (payload.entityId === entityId && String(payload.geoDataId) === activePoiId && payload.week === week) {
        onReady(payload.outputData);
      }
    });

    return () => {
      offEvent(socketKey);
    };
  }, [entityId, activePoiId, week]);
}
